// GET https://api.swiftaid.co.uk/donor/v1-dev/me/authorisation

export default {
  authorised: '2022-09-14T10:30:00.000Z',
  created: '2022-09-14T10:30:00.000Z',
  platform: 'JustGiving',
  expiry: '2027-04-05T23:59:59.999Z',
  canBeExtended: false,
}
